export default "__VITE_ASSET__49f19bc2__"